import { filter } from 'rxjs/operators';

import { Application } from '../models';

export function applicationPresent() {
    return filter(
        (
            application: Application | undefined | null
        ): application is Application =>
            application !== null && application !== undefined
    );
}
